import { IProvider } from "@web3auth/base";
import Web3 from "web3";

export default class EthereumRPC {
  private provider: IProvider;

  constructor(provider: IProvider) {
    this.provider = provider;
  }

  // Get user's Ethereum private key
  async getPrivateKey(): Promise<string> {
    try {
      const privateKey = await this.provider.request({
        method: "eth_private_key",
      });

      return privateKey as string;
    } catch (error) {
      return error as string;
    }
  }

  async getAccounts(): Promise<string[]> {
    try {
      const web3 = new Web3(this.provider as IProvider);

      // Get user's Ethereum public address
      const addresses = await web3.eth.getAccounts();

      return addresses;
    } catch (error) {
      return error as string[];
    }
  }
}
